import { generatedApi } from '@ocenkatech/common/api';
import { tokenReducer } from '@ocenkatech/common/models';
import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { authApi, authReducer } from 'entities/auth';

export const store = configureStore({
    reducer: {
        [generatedApi.reducerPath]: generatedApi.reducer,
        auth: authReducer,
        token: tokenReducer,
        [authApi.reducerPath]: authApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            generatedApi.middleware,
            authApi.middleware,
        ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
